import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_EMPLOYEE_FAILURE,
  FETCH_EMPLOYEE_REQUEST,
  FETCH_EMPLOYEE_SUCCESS,
  EmployeeActionType,
} from '../types/employeeTypes';
import { Employee } from 'src/types/model';

export const fetchEmployeeRequest = (): EmployeeActionType => ({
  type: FETCH_EMPLOYEE_REQUEST,
});

export const fetchEmployeeSuccess = (data: Employee[]): EmployeeActionType => ({
  type: FETCH_EMPLOYEE_SUCCESS,
  payload: data,
});

export const fetchEmployeeFailure = (error: string): EmployeeActionType => ({
  type: FETCH_EMPLOYEE_FAILURE,
  payload: error,
});

export const fetchEmployee = () => {
  return async (dispatch: Dispatch<EmployeeActionType>) => {
    dispatch(fetchEmployeeRequest());
    try {
      const request = await Service.get('/employees');
      const data: Employee[] = request?.data?.data?.employees;
      dispatch(fetchEmployeeSuccess(data));
    } catch (error: any) {
      dispatch(fetchEmployeeFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch employee');
    }
  };
};
